import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/builds/andy.c/gsn-frontend/layouts/auth.vue").then(m => m.default || m)),
  cart: defineAsyncComponent(() => import("/builds/andy.c/gsn-frontend/layouts/cart.vue").then(m => m.default || m)),
  clean: defineAsyncComponent(() => import("/builds/andy.c/gsn-frontend/layouts/clean.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/builds/andy.c/gsn-frontend/layouts/default.vue").then(m => m.default || m)),
  payment: defineAsyncComponent(() => import("/builds/andy.c/gsn-frontend/layouts/payment.vue").then(m => m.default || m))
}